export default "__VITE_PUBLIC_ASSET__d915553e__"